<template>
  <b-row>
    <b-alert :show="show_msg"
      >Selecione um conselho para selecionar mandatos</b-alert
    >
    <b-col cols="6" v-for="(options, key) in mandatos_conselho" :key="key">
      <b-form-group :label="options.label">
        <b-form-radio-group
          v-model="local_value"
          :options="options.options"
          :value="options.value"
          :state="state"
          stacked
        ></b-form-radio-group>
      </b-form-group>
      <b-alert :show="!options.options.length" variant="warning">
        {{ message_no_mandatos }}
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
    return_object: false,
    placeholder: {
      type: String,
      default: "Selecione um Conselheiro",
    },
    conselho_id: null,
    tipo_mandato: {
      type: String,
      default: 'conselheiro',
    }
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    changed_value: null,
    mandatos: [],
  }),
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);

        this.mandatos_conselho.forEach((mandato) => {
          const mandatoSelected = mandato.options.find((v) => v.id == value);

          if (mandatoSelected) {
            this.$emit("selected", mandatoSelected);
          }
        });

      },
      get() {
        return this.value;
      },
    },
    mandatos_conselho() {
      let values = [];
      this.mandatos.forEach((mandato) => {
        if (mandato.conselho_id == this.conselho_id) {
          const mandatoConselho = mandato;
          mandatoConselho["options"] = mandato.options.filter(
            (v) => v.tipo == this.tipo_mandato
          );
          values.push(mandatoConselho);
        }
      });
      return values;
    },
    show_msg() {
      return this.mandatos_conselho.length == 0;
    },
    message_no_mandatos() {
      var message = "Nenhum mandato para esse conselho";

      switch (this.tipo_mandato) {
        case "conselheiro":
          message =
            "Nenhum mandato para CONSELHEIROS registrado nesse conselho";
          break;
        case "mesa-diretora":
          message =
            "Nenhum mandato para MESAS DIRETORAS registrado nesse conselho";
          break;
      }

      return message;
    },
  },
  methods: {
    ...mapActions("conselheiros", ["ActionMandatosToSelect"]),
    async loadOptions() {
      this.mandatos = await this.ActionMandatosToSelect();
    },
    disabledConselho(id) {
      let disabled = this.conselho_id ? false : true;

      if (!disabled) {
        disabled = this.conselho_id != id;
      }

      return disabled;
    },
    async isValid() {
      let valid = false;
      await this.mandatos.forEach((mandato) => {
        let selected = _.find(mandato.options, {
          value: this.local_value,
        });
        if (selected && mandato.conselho_id == this.conselho_id) {
          valid = true;
        }
      });
      return valid;
    },
  },
  watch: {},
  created() {
    this.loadOptions();
  },
};
</script>

<style></style>
